<template>
    <div>
        <app-bar :title="tag.name"/>

        <v-layout>
            <v-progress-linear
                v-if="overlay"
                absolute
                indeterminate
            ></v-progress-linear>

            <div class="pt-8 pb-12 px-8">
                <div class="pb-10">
                    <v-btn
                        @click="edit"
                        class="sm mr-5"
                        color="primary"
                    >{{ t('general_action_edit') }}
                    </v-btn>
                    <v-btn
                        class="sm mr-5"
                        color="primary"
                        outlined
                        @click.prevent="suspend(tag)"
                    >
                        {{ tag.published ? t('general_action_suspend') : t('general_action_unsuspend') }}
                    </v-btn>
                    <confirm-modal
                        :title="t('general_title_confirm_action')"
                        @agree="del(tag)"
                    >
                        <template #default="{ on, attrs }">
                            <v-btn
                                class="sm"
                                color="orange"
                                outlined
                                v-on="on"
                                v-bind="attrs"
                            >{{ t('general_action_delete') }}</v-btn>
                        </template>
                    </confirm-modal>
                </div>
                <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                    <card-unit :items="items()">
                        <template #title>{{ t('tag_label_id') }}: {{ tag.id }}</template>
                    </card-unit>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useRouter } from '@/composition-api'
    import { useEnums } from '@/core/defaults'
    import { Tag } from '@/core/models/tag'
    import moment from 'moment/moment'
    import ConfirmModal from '@/components/ConfirmModal.vue'
    import CardUnit from '@/components/CardUnit.vue'

    export default defineComponent({
        components: {
            ConfirmModal,
            CardUnit
        },

        /**
         * Component constructor.
         *
         * @param props
         */
        setup(props) {
            const store = useStore()
            const router = useRouter()
            const i18n = useI18n()
            const id = router.currentRoute.params['id']

            const state = reactive({
                overlay: true,
                currentTab: <number | null>null,
            })

            const capture = () => {
                store.dispatch('tag/get', { id: id, payload: { published: '', relations: 'section' } }).then(() => {
                    state.overlay = false
                })
            }

            const tagModel = computed(() => <Tag>store.getters['tag/get'])

            const suspend = (tagModel: Tag) => {
                state.overlay = true
                store.dispatch('tag/update', {
                    id: tagModel.id,
                    payload: { published: ! tagModel.published }
                }).then(() => {
                    store.dispatch('notify', { color: 'success', message: i18n.t('general_notice_data_updated') })
                    capture()
                })
            }

            const edit = () => router.push({ name: 'tags.show', params: { id: <any>tagModel.value.id } })

            const del = (tagModel: Tag) => {
                state.overlay = true
                store.dispatch('tag/delete', { id: tagModel.id }).then(() => {
                    router.push({ name: 'tags' })
                })
            }

            const items = () => {
                let items = <any>[
                    { text: i18n.t('tag_label_slug'), value: tagModel.value.slug },
                    { text: i18n.t('tag_label_section'), value: tagModel.value.section.name },
                    { text: i18n.t('general_label_creation_date'), value: tagModel.value.createdAt.format('DD/MM/YYYY') },
                    { text: i18n.t('tag_label_sort_order'), value: tagModel.value.sortOrder },
                    { text: i18n.t('tag_label_published'), value: tagModel.value.published ? i18n.t('general_text_yes') : i18n.t('general_text_no') },
                ]
                return items
            }

            onMounted(() => {
                capture()
            })

            return {
                capture,
                items,
                tag: tagModel.value,
                moment,
                edit,
                del,
                suspend,
                ...useI18n(),
                ...useEnums(),
                ...toRefs(state)
            }
        }
    })
</script>
